export default "__VITE_ASSET__CtCWee7k__"